import React from 'react';
import { Reveal } from './ui/Reveal';
import { routeSteps } from '../data/content';
export function NotJustInfoSection() {
  return <section aria-labelledby="ruta-bases" className="border-y-2 border-volt/25 bg-carbon" data-id="element-125" data-mp="z04o5lkqcfez">
      <div className="mx-auto max-w-page px-3 py-8 text-center sm:px-6 sm:py-10" data-id="element-126" data-mp="1dosftgrgg4zn">
        <Reveal data-id="element-127" data-mp="18vzdezjgl8qq">
          <h2 id="ruta-bases" className="mx-auto max-w-3xl font-display text-xl uppercase leading-[1.08] text-white sm:text-3xl lg:text-4xl" data-id="element-128" data-mp="18vg5mbniw0qf">
            Esto no es solo información sobre electricidad
          </h2>
          <p className="mt-1 font-display text-base uppercase text-volt sm:text-xl" data-id="element-129" data-mp="1wmv8c5j7ok27">
            Es una ruta para construir tus bases.
          </p>
        </Reveal>

        <ul className="mx-auto mt-4 grid max-w-4xl gap-2 text-left sm:grid-cols-2 lg:grid-cols-3" data-id="element-130" data-mp="1rlecwpjhxpt0">
          {routeSteps.map((step, i) => <Reveal key={step.text} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-lg border border-white/10 bg-night px-3 py-2.5 text-[0.8rem] font-semibold text-white sm:text-sm" data-id="element-131" data-mp="3tfdicu9xtcxs" data-mpi={i}>
              <span aria-hidden="true" className="text-base" data-id="element-132" data-mp="2j5i1x49muosa">
                {step.icon}
              </span>
              {step.text}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-5 max-w-2xl" data-id="element-133" data-mp="2nxt3ebk0uimy">
          <p className="text-[0.85rem] leading-snug text-steel sm:text-base" data-id="element-134" data-mp="2sujfknspgu33">
            Tu objetivo no es terminar el último tomo y decir “lo leí”.
          </p>
          <p className="mt-1.5 text-[0.85rem] leading-snug text-white sm:text-base" data-id="element-135" data-mp="31v7rncyjgkdc">
            <span className="font-bold" data-id="element-136" data-mp="36ukf9zx8hvgz">Tu objetivo</span> es poder mirar un
            esquema básico, reconocer sus elementos, comprender qué función
            cumplen y explicar con tus propias palabras la lógica que existe
            detrás.
          </p>
        </Reveal>
      </div>
    </section>;
}